import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  controls: "",
  class: "n-video-message__video"
}
const _hoisted_2 = ["src"]

import { PropType } from 'vue';
import moment from 'moment';
import NIcon from '../../brand/icon/icon.vue';
import NTooltip from '../../control/tooltip/tooltip.vue';
import NAvatar from '../avatar/avatar.vue';
import { VideoMessage, Message } from './message';
import { MessageStatus } from './messageStatus';


export default /*@__PURE__*/_defineComponent({
  __name: 'video-message',
  props: {
  message: {
    type: Object as PropType<VideoMessage>,
    required: true,
  },
  displayAvatar: {
    type: Boolean,
    default: false,
  },
  enableAvatarTooltip: {
    type: Boolean,
    default: false,
  },
  tooltipPosition: {
    type: String as PropType<'right' | 'left'>,
    default: 'right',
  },
},
  setup(__props) {



function getMessageTimestamp(timestamp: Date): string {
  return moment(timestamp).format('HH:mm');
}

function shouldShowAlertIcon(m: Message) {
  return m.status === MessageStatus.DeliveryFailed;
}

function isRead(m: Message) {
  return m.status === MessageStatus.Read;
}

function shouldShowTickIcon(m: Message) {
  switch (m.status) {
    case MessageStatus.DeliverySucceeded:
    case MessageStatus.Read:
    case MessageStatus.Received:
    case MessageStatus.Sent:
      return true;
    default:
      return false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["n-video-message", {
      'n-video-message--left': __props.tooltipPosition === 'right',
      'n-video-message--right': __props.tooltipPosition === 'left',
    }])
  }, [
    (__props.displayAvatar)
      ? (_openBlock(), _createBlock(NAvatar, {
          key: 0,
          size: "s",
          name: __props.message.name,
          imageUrl: __props.message.avatarUrl,
          enableTooltip: __props.enableAvatarTooltip,
          class: _normalizeClass(["n-app-message__avatar", {
        'n-video-message__avatar--left': __props.tooltipPosition === 'right',
        'n-video-message__avatar--right': __props.tooltipPosition === 'left',
      }])
        }, null, 8, ["name", "imageUrl", "enableTooltip", "class"]))
      : _createCommentVNode("", true),
    _createVNode(NTooltip, { position: __props.tooltipPosition }, {
      default: _withCtx(() => [
        _createElementVNode("video", _hoisted_1, [
          _createElementVNode("source", {
            src: __props.message.mediaSrc
          }, null, 8, _hoisted_2)
        ])
      ]),
      message: _withCtx(() => [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(getMessageTimestamp(__props.message.timestampUtc)) + " ", 1),
          (shouldShowAlertIcon(__props.message))
            ? (_openBlock(), _createBlock(NIcon, {
                key: 0,
                icon: "alert",
                fill: "#ff6348"
              }))
            : _createCommentVNode("", true),
          (shouldShowTickIcon(__props.message))
            ? (_openBlock(), _createBlock(NIcon, {
                key: 1,
                icon: "tick",
                fill: isRead(__props.message) ? '#57d272' : '#bdbdbd'
              }, null, 8, ["fill"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["position"])
  ], 2))
}
}

})